import React, { useState } from 'react';
import MainContent from './MainContent'; // Ensure proper path
import DashboardLayout from '../components/DashboardLayout/DasboardLayout'; // Ensure proper path
import Driversdisplay from './Driversdisplay';

const ActiveDriversLocationsMap = () => {
  const [selectedTrip, setSelectedTrip] = useState(null);
  const [collapsed, setCollapsed] = useState(false); // State for sidebar collapse
  const darkMode = false; // Set your dark mode state here

  return (
    <DashboardLayout>
      <Driversdisplay/>
    </DashboardLayout>
  );
};

export default ActiveDriversLocationsMap;
